import { Divider, Grid } from "@material-ui/core";
import React from "react";
import { formatDocument } from "../../../../../../../../utils/formatters";
import DataCell from "../../cells/data";

const IncomeData = ({ data }) =>
  data && data.length > 0 ? (
    <>
      <Divider className="mt-20 mb-20 w-100" />

      <Grid spacing={3} container>
        <Grid xs={12} className="qd-data-cell-label" item>
          {`${data.length === 1 ? "Registro" : "Registros"} de trabalho`}
        </Grid>

        {data.map(
          ({ cboDescricao, empresa: { razaoSocial, cnpj }, faixaSalarial }) => (
            <React.Fragment key={`${cboDescricao}-${cnpj}`}>
              <DataCell
                xs={12}
                md={6}
                value={
                  <>
                    <div>{cboDescricao}</div>
                    <div>{`Renda estimada ${faixaSalarial?.toLowerCase()}`}</div>
                  </>
                }
              />

              <DataCell
                xs={12}
                md={6}
                value={
                  <>
                    <div>{razaoSocial}</div>
                    <div>{formatDocument(cnpj)}</div>
                  </>
                }
              />
            </React.Fragment>
          )
        )}
      </Grid>
    </>
  ) : null;

export default IncomeData;
